import React from "react";
import { CompactTable } from "@table-library/react-table-library/compact";

import { useTheme } from "@table-library/react-table-library/theme";
import { getTheme } from "@table-library/react-table-library/baseline";
import { TableScripts } from "../../../../BP2Components/Table/tableScripts";
import { Button, Empty } from "../../../../BP2Components";
import { createFilterRows } from "./TableFIlterScripts";

import { v4 as uuidv4 } from "uuid";

interface TableFiltersProps {
   columns: any;
   rows: any;
   setEditedListFilters: any;
   setCurrentFilter: any;
   setIsModalOpen: any;
}

const TableFilters: React.FC<TableFiltersProps> = ({
   columns,
   rows,
   setEditedListFilters,
   setCurrentFilter,
   setIsModalOpen,
}) => {
   const handleAddRow = () => {
      const newRow = {
         id: uuidv4(),
         name: "",
         description: "",
         active: false,

         filterSections: [],
      };

      setEditedListFilters((prevFilters) =>
         Array.isArray(prevFilters) ? [...prevFilters, newRow] : [newRow],
      );
      setCurrentFilter(newRow);
      setIsModalOpen(true);
   };

   const updatedColumns = columns?.map((col: any) => {
      if (col.id === "add") {
         return {
            ...col,
            label: (
               <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                     style={{ width: "32px", height: "32px" }}
                     buttonType="primary"
                     onClick={handleAddRow}
                  >
                     <span className="material-symbols-outlined">add</span>
                  </Button>
               </div>
            ),
         };
      }
      return col;
   });

   const theme = useTheme([
      getTheme(),
      {
         Table: `
           --data-table-library_grid-template-columns: ${TableScripts.getColumnWidths(columns)};
           overflow: visible;
         `,
      },
   ]);

   return (
      <div className="table-component filters">
         <CompactTable
            columns={updatedColumns}
            data={{ nodes: createFilterRows(rows) }}
            theme={theme}
            layout={{ custom: true, horizontalScroll: true, fixedHeader: true }}
            rowProps={(item) => ({
               className: item._className,
            })}
         />

         {createFilterRows(rows)?.length === 0 && (
            <div
               style={{
                  padding: "1rem",
                  textAlign: "center",
                  color: "#999",
                  fontStyle: "italic",
               }}
            >
               <Empty description="Brak filtrów do wyświetlenia" />
            </div>
         )}
      </div>
   );
};

export default TableFilters;
